export function trimForwardSlashes(url: string): string {
  return url.startsWith("//") ? url.slice(2) : url;
}
